export const openings = [
  {
    title: 'Engineering',
    jobs: [
      { title: 'Senior Software Engineer', location: 'Salt Lake City, UT', remote: true },
    ],
  },
  {
    title: 'Sales',
    jobs: [
      {
        title: 'Life Insurance Sales Representative',
        location: 'South Jordan, UT',
        remote: true,
      },
      {
        title: 'Business Development Manager',
        location: 'Salt Lake City, UT',
        remote: false,
      },
      { title: 'Account Executive', location: 'Salt Lake City, UT', remote: false },
    ],
  },
  {
    title: 'Operations',
    jobs: [
      {
        title: 'Customer Service Representative',
        location: 'Salt Lake City, UT',
        remote: true,
      },
      {
        title: 'Customer Service Representative',
        location: 'Tampa, FL',
        remote: false,
      },
    ],
  },
]

export const positions = openings
  .flatMap((x) => x.jobs)
  .map((y) => `${y.title} - ${y.location}`)
